"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomExitedEventArgs = void 0;
const EventType_1 = require("../EventType");
class RoomExitedEventArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = EventType_1.EventType.RoomExited;
        this.__typeName = "RoomExited";
    }
}
exports.RoomExitedEventArgs = RoomExitedEventArgs;
